/* =====================================================
   BASKETPOINT WISHLIST SYSTEM
   ===================================================== */

(function () {

  const STORAGE_KEY = 'basketpoint_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

    window.dispatchEvent(
      new CustomEvent('basketpoint:wishlist-updated', {
        detail: { items: items }
      })
    );
  }

  function isWishlisted(productId) {
    return getWishlist().some(
      item => String(item.id) === String(productId)
    );
  }

  function updateButton(button, active) {

    button.classList.toggle('is-active', active);

    button.setAttribute(
      'aria-pressed',
      active ? 'true' : 'false'
    );

    const tooltip =
      button.querySelector('.bp-wishlist-tooltip');

    if (tooltip) {
      tooltip.textContent =
        active
          ? 'Remove from wishlist'
          : 'Add to wishlist';
    }
  }

  function updateAllButtons(productId, active) {

    document
      .querySelectorAll(
        '[data-bp-wishlist][data-product-id="' +
        productId +
        '"]'
      )
      .forEach(button => {

        updateButton(button, active);

      });
  }

  function toggleWishlist(button) {

    const productId =
      button.dataset.productId;

    let wishlist = getWishlist();

    const existingIndex =
      wishlist.findIndex(
        item =>
          String(item.id) === String(productId)
      );

    if (existingIndex > -1) {

      wishlist.splice(existingIndex, 1);

      saveWishlist(wishlist);

      updateAllButtons(productId, false);

    } else {

      const product = {

        id: productId,

        handle:
          button.dataset.productHandle || '',

        title:
          button.dataset.productTitle || '',

        url:
          button.dataset.productUrl || '',

        image:
          button.dataset.productImage || '',

        price:
          button.dataset.productPrice || ''

      };

      wishlist.unshift(product);

      saveWishlist(wishlist);

      updateAllButtons(productId, true);
    }
  }

  function initialiseButtons() {

    document
      .querySelectorAll('[data-bp-wishlist]')
      .forEach(button => {

        const productId =
          button.dataset.productId;

        updateButton(
          button,
          isWishlisted(productId)
        );

      });
  }

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '[data-bp-wishlist]'
        );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      toggleWishlist(button);

    }
  );

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initialiseButtons
    );

  } else {

    initialiseButtons();

  }

  window.BasketPointWishlist = {

    get: getWishlist,

    save: saveWishlist,

    remove: function (productId) {

      const wishlist =
        getWishlist().filter(
          item =>
            String(item.id) !==
            String(productId)
        );

      saveWishlist(wishlist);

      updateAllButtons(
        productId,
        false
      );

      return wishlist;
    }

  };

})();